import React, { useState } from "react";
import { useForm, validators } from "@hooks";
import classNames from "classnames";
import { ExclamationCircleIcon } from "@heroicons/react/24/solid";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import PropTypes from 'prop-types';

const Credentials = ({ submit, initial, children }) => {

    const initialState = { email: ``, password: ``, confirm: ``, ...initial };
    const [show, setShow] = useState({ password: false, confirm: false });

    const validations = {
        email: (val) => validators.isValidEmail(val) || { email: `Email is not valid` },
        password: (val) => validators.validatePassword(val),
        confirm: (val, values) => compare(val, values[`password`]) || { confirm: `Passwords do not match` }
    };

    const toggleShow = (name) => {
        const update = { ...show, [name]: !show[name] };
        setShow(update);
    };

    const compare = (val, match) => val === match;

    const { values, errors, changeHandler, submitHandler } = useForm(initialState, {}, validations, submit);

    return (
        <>
            {children}
            <form className="space-y-5" method="POST" onSubmit={submitHandler} >
                <div className="flex flex-col bg-sb-frame rounded-xl shadow-sb p-5 space-y-3">
                    <div>
                        <label htmlFor="email" className="font-semibold text-gray-700">Email</label>
                        <div className="relative mt-1 rounded-md shadow-sm">
                            <input type="text" name="email" id="email" className={classNames(`block w-full rounded-md shadow-md focus:outline-none text-gray-600 read-only:bg-gray-100`, { "input-error": errors.email })} value={values.email} readOnly={true} onChange={changeHandler} aria-invalid="true" aria-describedby="email-error" />
                            {
                                errors.email &&
                                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                                    <ExclamationCircleIcon className="fill-red-500 h-6" />
                                </div>
                            }
                        </div>
                        {
                            errors.email &&
                            <p className="mt-2 text-sm text-red-600" id="email-error">{errors.email}</p>
                        }
                    </div>
                    <div>
                        <label htmlFor="password" className="font-semibold text-gray-700">Password</label>
                        <div className="relative mt-1 rounded-md shadow-sm">
                            <input
                                type={show.password ? `text` : `password`}
                                maxLength="20"
                                name="password"
                                id="password"
                                className={classNames(`pr-16 block w-full rounded-md shadow-md focus:outline-none text-gray-600`, { "input-error": errors.password })}
                                value={values.password}
                                onChange={changeHandler}
                                aria-invalid="true"
                                aria-describedby="email-error" />
                            <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                                {
                                    errors.password &&
                                    <ExclamationCircleIcon className="fill-red-500 h-6 pr-1" />
                                }
                                <div className="cursor-pointer" onClick={() => toggleShow(`password`)}>
                                    {
                                        !show.password &&
                                        <EyeIcon className="h-6" />
                                    }
                                    {
                                        show.password &&
                                        <EyeSlashIcon className="h-6" />
                                    }
                                </div>
                            </div>
                        </div>
                        <span className="text-gray-600 text-sm" >Use 9-20 characters and include a mix of upper and lowercase letters, numbers, and special characters. Do not use spaces.</span>
                        {
                            errors.password &&
                            <ul className="list-disc ml-3">
                                {errors.password.map((e, index) => <li key={index} className="text-sm text-red-600" id="email-error">{e}</li>)}

                            </ul>

                        }
                    </div>
                    <div>
                        <label htmlFor="confirm" className="font-semibold text-gray-700">Confirm Password</label>
                        <div className="relative mt-1 rounded-md shadow-sm">
                            <input
                                type={show.confirm ? `text` : `password`}
                                maxLength="20"
                                name="confirm"
                                id="confirm"
                                className={classNames(`pr-16 block w-full rounded-md shadow-md focus:outline-none text-gray-600`, { "input-error": errors.confirm })}
                                value={values.confirm}
                                onChange={changeHandler}
                                aria-invalid="true"
                                aria-describedby="email-error" />
                            <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                                {
                                    errors.confirm &&
                                    <ExclamationCircleIcon className="fill-red-500 h-6 pr-1" />
                                }
                                <div className="cursor-pointer" onClick={() => toggleShow(`confirm`)}>
                                    {
                                        !show.confirm &&
                                        <EyeIcon className="h-6" />
                                    }
                                    {
                                        show.confirm &&
                                        <EyeSlashIcon className="h-6" />
                                    }
                                </div>
                            </div>
                        </div>
                        {
                            errors.confirm &&
                            <p className="mt-2 text-sm text-red-600" id="email-error">{errors.confirm}</p>
                        }
                    </div>
                </div>
                <button type="submit" className="btn btn-primary">Create Account</button>
            </form>
        </>
    );
};

Credentials.propTypes = {
    submit: PropTypes.func.isRequired,
    initial: PropTypes.object.isRequired,
    children: PropTypes.any.isRequired
};

export default Credentials;